import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const categories = [
  {
    title: "Coches premium",
    sub: "Mercedes-Benz, Audi, BMW",
    img: "https://images.unsplash.com/photo-1629820408206-e9fc918abf63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXIlMjBpbnRlcmlvciUyMGRyaXZlciUyMG5pZ2h0fGVufDB8fHx8MTc4MTE3MjYzMnww&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-7",
  },
  {
    title: "SUVs",
    sub: "Q5, GLE, X5, Cayenne",
    img: "https://images.unsplash.com/photo-1611168935847-4bf3f7291cde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxtZXJjZWRlcyUyMHN1diUyMGRhcmt8ZW58MHx8fHwxNzgxMTcyNjMyfDA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-5",
  },
  {
    title: "Deportivos",
    sub: "911, M Series, RS, AMG",
    img: "https://images.unsplash.com/photo-1597858520171-563a8e8b9925?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxwb3JzY2hlJTIwOTExJTIwZGFyayUyMGNpbmVtYXRpY3xlbnwwfHx8fDE3ODExNzI2MzJ8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-5",
  },
  {
    title: "Coches familiares",
    sub: "Avant, Touring, Estate",
    img: "https://images.unsplash.com/photo-1561924563-d9ad0f32b23f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxhdWRpJTIwc3RhdGlvbiUyMHdhZ29uJTIwZGFya3xlbnwwfHx8fDE3ODExNzI2MzJ8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-7",
  },
  {
    title: "Furgonetas",
    sub: "VW, Mercedes Vito, Vivaro",
    img: "https://images.unsplash.com/photo-1727502356107-6fb964cf74f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB2YW4lMjBibGFja3xlbnwwfHx8fDE3ODExNzI2MzJ8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-6",
  },
  {
    title: "Vehículos comerciales",
    sub: "Sprinter, Crafter, Transit",
    img: "https://images.unsplash.com/photo-1775054185026-8dc74fac136f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb21tZXJjaWFsJTIwdmFuJTIwZGFya3xlbnwwfHx8fDE3ODExNzI2MzJ8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-6",
  },
];

export const Categories = () => {
  return (
    <section
      id="vehiculos"
      className="relative py-24 sm:py-32 bg-[#0A0A0A] border-t border-white/5"
      data-testid="categories-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-6 mb-16"
        >
          <div className="max-w-2xl">
            <span className="text-xs uppercase tracking-[0.32em] text-[#D4AF37]">Categorías</span>
            <h2 className="font-heading mt-6 text-3xl sm:text-5xl font-light tracking-tight text-[#FFFFF0] leading-tight">
              Cualquier vehículo. Cualquier propósito.
            </h2>
          </div>
          <p className="text-sm text-[#A3A3A3] max-w-md font-light leading-relaxed">
            Desde un deportivo de colección hasta una furgoneta para tu negocio. Encontramos en Alemania exactamente lo que buscas.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
          {categories.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              className={`group relative overflow-hidden border border-white/5 transition-all duration-500 cursor-pointer card-lift ${c.span}`}
              data-testid={`category-card-${i}`}
            >
              <div className="aspect-[16/10] lg:aspect-[16/11] overflow-hidden">
                <img
                  src={c.img}
                  alt={c.title}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8 flex items-end justify-between">
                <div>
                  <p className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-2">{c.sub}</p>
                  <h3 className="font-heading text-xl sm:text-2xl font-light text-[#FFFFF0]">{c.title}</h3>
                </div>
                <div className="w-10 h-10 border border-white/20 flex items-center justify-center group-hover:bg-[#D4AF37] group-hover:border-[#D4AF37] transition-all">
                  <ArrowUpRight className="w-4 h-4 text-[#FFFFF0] group-hover:text-black" strokeWidth={1.5} />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;
